import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "MoveFolderPosition" */ "./lazyIndex"), { name: "MoveFolderPosition" });

export const lazyMoveFolderPosition: LazyAction<typeof lazyIndex.onMoveFolderPosition, typeof lazyModule> = new LazyAction(lazyModule, m => m.onMoveFolderPosition);
export const lazyMoveFolderPositionUpDown: LazyAction<typeof lazyIndex.onMoveFolderPositionUpDown, typeof lazyModule> = new LazyAction(lazyModule, m => m.onMoveFolderPositionUpDown);
